

export default () => {
    let axis = {
        axisLine : {
            lineStyle: {
                color: '#757fa3'
            }
        },
        axisLabel : {
            show: true,
            textStyle: {
                color: "rgba(255,255,255,.5)", //坐标轴文字颜色
            },
            interval: 0,
        },
        axisTick : {
            //不显示刻度
            show: false,
        },
        splitLine : {
            show: false,
        },
        nameTextStyle: {
            color: "rgba(255,255,255,.5)",
        },
    }

    let grid = {
        left: "1%",
        right: "8%",
        bottom: "1%",
        top: '24%',
        containLabel: true,
    }
    
    let title = {
        textStyle: {
            color: "#fffcf9",
            fontSize: 16,
        },
        left: '10px',
        top: '10px',
    }

    let legend = {
        textStyle: {
            color: "rgba(255,255,255,.5)",
        },
        itemWidth: 10,
        itemHeight: 10,
    }

    return { axis,grid,title,legend }
}






